import { BudgetovacIframe } from "@components/widgets/BudgetovacIframe";
import { withCan } from "@src/utils/components/permissions";

export default withCan({ do: "integration_budgetovac" }, BudgetovacIframe);
